// extracted by mini-css-extract-plugin
export var borderRadius = "_5o-4";
export var large = "_5o-3";
export var logoContainer = "_5o-0";
export var nameLogo = "_5o-2";
export var small = "_5o-1";